import { SetModelJsonResource } from "@/types/setTypes";
import { UserModelJsonResource } from "@/types/userTypes";
import api from "./axios";

export const setApi = {
  // Get a single set by nano_id (fallback for direct navigation)
  getSet: async (setNanoId: string): Promise<SetModelJsonResource> => {
    const response = await api.get(`/api/sets/${setNanoId}`);
    const jsonResponse = response.data as {
      set: SetModelJsonResource;
    };

    if (import.meta.env.DEV) {
      console.log(">>> getSet:", jsonResponse);
    }

    return jsonResponse.set;
  },

  deleteSet: async (setNanoId: string): Promise<void> => {
    const response = await api.post(`/api/sets/delete`, {
      set_nano_id: setNanoId,
    });
    const jsonResponse = response.data;
    if (import.meta.env.DEV) {
      console.log(">>>deleteSet", jsonResponse);
    }
    return jsonResponse;
  },

  // Add a workout set (works for both existing and new exercises)
  trackNewSetByText: async (
    exerciseNanoId: string,
    exerciseName: string,
    weight: number,
    reps: number,
    unit: string = "lb"
  ): Promise<SetModelJsonResource> => {
    const payload = {
      exercise_nano_id: exerciseNanoId,
      exercise_name: exerciseName,
      weight,
      reps,
      unit,
    };
    const response = await api.post("/api/sets/by-text", payload);
    const jsonResponse = response.data as {
      set: SetModelJsonResource;
      user: UserModelJsonResource;
    };

    if (import.meta.env.DEV) {
      console.log(">>> 新建了 set 之后 backend 返回的数据：", jsonResponse);
    }

    return jsonResponse.set;
  },

  // Record a new workout set using audio
  trackNewSetByAudio: async (
    audioBlob: Blob
  ): Promise<SetModelJsonResource> => {
    const formData = new FormData();
    const mimeType = audioBlob.type.split(";")[0];
    const file_extension = mimeType.split("/")[1] || "webm";
    formData.append(
      "audio_blob",
      audioBlob,
      `audio-${Date.now()}.${file_extension}`
    );
    const response = await api.post("/api/sets/by-audio", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const jsonResponse = response.data as {
      set: SetModelJsonResource;
      user: UserModelJsonResource;
    };
    if (import.meta.env.DEV) {
      console.log(">>>trackNewSetByAudio", jsonResponse);
    }

    return jsonResponse.set;
  },

  // Update a set's weight, reps, and exercise
  updateSet: async (
    setNanoId: string,
    weight: number,
    reps: number,
    unit: string,
    trainAtTime?: string,
    exerciseNanoId?: string,
    exerciseName?: string
  ): Promise<SetModelJsonResource> => {
    const payload = {
      set_nano_id: setNanoId,
      weight,
      reps,
      unit,
      ...(trainAtTime && { train_at_time: trainAtTime }),
      ...(exerciseNanoId && { exercise_nano_id: exerciseNanoId }),
      ...(exerciseName && { exercise_name: exerciseName }),
    };
    const response = await api.post("/api/sets/update", payload);
    const jsonResponse = response.data as {
      set: SetModelJsonResource;
      user: UserModelJsonResource;
    };

    if (import.meta.env.DEV) {
      console.log(">>> updated set:", jsonResponse);
    }

    return jsonResponse.set;
  },

  // Duplicate a set
  duplicateSet: async (setNanoId: string): Promise<SetModelJsonResource> => {
    const payload = {
      set_nano_id: setNanoId,
    };
    const response = await api.post("/api/sets/duplicate", payload);
    const jsonResponse = response.data as {
      set: SetModelJsonResource;
      user: UserModelJsonResource;
    };

    if (import.meta.env.DEV) {
      console.log(">>> duplicated set:", jsonResponse);
    }

    return jsonResponse.set;
  },
};
